module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body"
  }, [_c('WorkingCapitalLandingPageFilter'), _vm._v(" "), _c('Benefits'), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "background": "white"
    }
  }, [_c('div', {
    staticClass: "container platform products"
  }, [_c('div', {
    staticClass: "row equipment-product"
  }, [_c('div', {
    staticClass: "col-12 col-lg-5 offset-lg-1 equipment-product-left"
  }, [_c('lazy-youtube-video', {
    style: ({
      width: '100%',
      maxWidth: '560px',
      height: 'auto'
    }),
    attrs: {
      "src": "https://www.youtube.com/embed/7v1c7cM19l0",
      "iframeAttributes": {
        allowfullscreen: true,
        frameborder: 0,
        allow: 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture',
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-5 equipment-product-right"
  }, [_c('div', [_c('h2', {
    staticClass: "product-title"
  }, [_vm._v("\n              Maximize your profitability with flexible equipment financing\n              and asset-based loans\n            ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "hover-element"
  }, [_c('p', [_c('span', {
    staticClass: "product-read-more"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.toggle1 = !_vm.toggle1
      }
    }
  }, [_vm._v("Read more\n                    "), _c('i', {
    staticClass: "fa fa-chevron-right",
    staticStyle: {
      "color": "#5456ff"
    }
  })])])]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.toggle1),
      expression: "toggle1"
    }],
    staticClass: "hover-display-content"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "700"
    }
  }, [_vm._v("American Credit understands the dilemma facing borrowers in\n                  equipment financing: often the financing and purchase are\n                  bundled. ")]), _vm._v("We arm the equipment purchaser with pre-approval on financing\n                so that, when they shop, they concentrate on getting the best\n                deal on the equipment price. Our pre-approvals significantly\n                enhance the equipment purchasers’ bargaining power.\n              ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "container platform products"
  }, [_c('div', {
    staticClass: "row invoice-product"
  }, [_c('div', {
    staticClass: "col-12 col-lg-5 offset-lg-1 invoice-product-left"
  }, [_c('div', [_c('h2', {
    staticClass: "product-title"
  }, [_vm._v("\n              Better cash flow with invoice/AR financing\n            ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "hover-element"
  }, [_c('p', [_c('span', {
    staticClass: "product-read-more"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.toggle2 = !_vm.toggle2
      }
    }
  }, [_vm._v("Read more\n                    "), _c('i', {
    staticClass: "fa fa-chevron-right",
    staticStyle: {
      "color": "#5456ff"
    }
  })])])]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.toggle2),
      expression: "toggle2"
    }],
    staticClass: "hover-display-content"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "700"
    }
  }, [_vm._v("For borrowers in invoice financing it is difficult to find\n                  a stable credit provider who can handle their frequent\n                  short-term credit needs. ")]), _vm._v("American Credit commits itself to provide our clients not\n                only invoice financing but also secured loans such as\n                inventory financing, bridge loans, upgrading and renovations,\n                as well as opening new branches. We are your one-stop business\n                loan provider.\n              ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-5 invoice-product-right"
  }, [_c('img', {
    attrs: {
      "src": require('../assets/imgs/female-factory.jpeg'),
      "srcset": require('../assets/imgs/female-factory-320w.jpeg') +
        ' 320w, ' +
        require('../assets/imgs/female-factory-640w.jpeg') +
        ' 640w, ' +
        require('../assets/imgs/female-factory-960w.jpeg') +
        ' 960w',
      "alt": "confident female business owner near factory equipment purchased with invoice financing",
      "width": "500",
      "height": "350"
    }
  })])])])]), _vm._v(" "), _c('Testimonial'), _vm._v(" "), _c('HowWorks'), _vm._v(" "), _c('Trust'), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "product-summary"
  }, [_c('span', [_vm._v("American Credit"), _c('sup', [_vm._v("®")]), _vm._v(" Asset-Based Loans starting\n                4.5%")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "product-summary"
  }, [_c('span', [_vm._v("We understand where your time is best spent. So our\n                application process takes almost no time at all. ")]), _c('span', {
    staticStyle: {
      "color": "#5456ff",
      "font-weight": "400"
    }
  }, [_c('a', {
    attrs: {
      "href": "/get-start"
    }
  }, [_vm._v("See how fast we make it.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "padding": "40px 10px"
    }
  }, [_c('div', {
    staticClass: "elfsight-app-8279c03d-9a65-4465-b949-ecb8d18697e0"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "background-color": "white"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-lg-10 offset-lg-1"
  }, [_c('div', {
    staticStyle: {
      "padding-top": "20px",
      "font-family": "Biotif",
      "font-weight": "400",
      "font-size": "14px"
    }
  }, [_vm._v("\n            Footnote\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('ul', {
    staticStyle: {
      "margin": "0",
      "padding-left": "15px"
    }
  }, [_c('li', {
    staticStyle: {
      "list-style": "decimal",
      "font-family": "Biotif",
      "font-weight": "400",
      "font-size": "14px"
    }
  }, [_vm._v("Please consult with a tax professional for qualification and details.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1db7fac6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/workingCapitalLandingPage.vue
// module id = 1953
// module chunks = 5